import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { IsCreatingCtx, IsEditingCtx } from './context';
import { Bars3Icon } from '@heroicons/react/24/outline';
import { LogoHasilHoki } from '../../assets';
import { Button } from '@/components/ui/button';
import Sidebar from './components/sidebar';

const Dashboard: React.FC = () => {
  const [isCreating, setIsCreating] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  return (
    <>
      <IsCreatingCtx.Provider value={{ isCreating, setIsCreating }}>
        <IsEditingCtx.Provider value={{ isEditing, setIsEditing }}>
          <div className='flex h-full bg-gray-50 dark:bg-gray-900 overflow-hidden'>
            <Sidebar
              collapsed={collapsed}
              setCollapsed={setCollapsed}
              isMobileOpen={isMobileOpen}
              setIsMobileOpen={setIsMobileOpen}
            />

            <div
              className={`flex min-w-0 flex-1 flex-col overflow-hidden ${
                collapsed ? 'lg:ml-16' : 'lg:ml-64'
              } transition-all duration-300`}
            >
              {/* Mobile top navigation */}
              <div className='lg:hidden'>
                <div className='flex items-center justify-between py-2 px-4 sm:px-6'>
                  <div>
                    <img className='h-8 w-auto' src={LogoHasilHoki.default} alt='Hasil Hoki' />
                  </div>
                  <div>
                    <Button
                      type='button'
                      variant='ghost'
                      size='icon'
                      className='text-primary-foreground hover:bg-primary/90'
                      onClick={() => setIsMobileOpen(true)}
                    >
                      <span className='sr-only'>Open sidebar</span>
                      <Bars3Icon className='h-6 w-6' aria-hidden='true' />
                    </Button>
                  </div>
                </div>
              </div>

              <main
                className='relative h-screen overflow-y-auto p-4 lg:p-6 bg-gray-50 dark:bg-gray-800'
                onClick={() => {
                  setIsCreating(false);
                  setIsEditing(false);
                }}
              >
                <Outlet />
              </main>
            </div>
          </div>
        </IsEditingCtx.Provider>
      </IsCreatingCtx.Provider>
    </>
  );
};

export default Dashboard;
